import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
import { CommodityStatusCode } from '@bechtel/types';

export const EllipseStyled = styled(Box).attrs({ mx: { sm: '200' }, alignSelf: { sm: 'center' } })`
  ${({ theme }) => css`
    width: ${theme.spacings[100]};
    height: ${theme.spacings[100]};
    background-color: ${theme.colors.grey[700]};
  `}
`;

interface WeldStatusProps {
  status?: CommodityStatusCode;
}

export const getBackgroundStatusColor = (props: WeldStatusProps) => {
  switch (props.status) {
    case CommodityStatusCode.VT_APPROVED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.green[200]};
      `;
    case CommodityStatusCode.CLAIMED:
    case CommodityStatusCode.FITUP_INSPECTION:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.orange[200]};
      `;
    case CommodityStatusCode.BLOCKED:
      return css`
        background-color: ${({ theme }) => theme.colors.red[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.red[200]};
      `;
    case CommodityStatusCode.VT_SENT_BACK:
    case CommodityStatusCode.SENT_BACK_TO_PIPING:
      return css`
        background-color: ${({ theme }) => theme.colors.purple[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.purple[200]};
      `;
    case CommodityStatusCode.READY_TO_WELD:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.blue[200]};
      `;
    //TODO: Uncomment this once this status added to CommodityStatusCode
    // case CommodityStatusCode.ASSIGNED:
    //   return css`
    //     background-color: ${({ theme }) => theme.colors.yellow[400]};
    //     box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.yellow[200]};
    //   `;
    case CommodityStatusCode.FITUP_REQUESTED:
      return css`
        background-color: ${({ theme }) => theme.colors.yellow[300]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.yellow[200]};
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
        box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.grey[200]};
      `;
  }
};

export const WeldStatusStyled = styled.div<WeldStatusProps>`
  ${({ theme }) => css`
    border-radius: ${theme.radii[200]};
    margin-right: ${theme.spacings[450]};
    min-width: ${theme.spacings[200]};
  `}
  ${getBackgroundStatusColor}
`;
